import { getProductsFacilitySubTypeSuggestions } from '@/api/generated/products-placeholders/products-placeholders';
import type { FacilitySubTypeSuggestion } from '@/api/generated/schemas';
import { createLegacyEntitySelector, type LegacyEntityRef } from './createLegacyEntitySelector';

/** UI ref podtypu ubytovacího zařízení (facility sub-type). */
export type FacilitySubTypeRef = LegacyEntityRef;

/**
 * Selektor podtypů ubytovacího zařízení nad `POST /api/products/facility-subtypes/suggestions`.
 * Používá se v sekci Ubytování detailu placeholderu.
 */
const facilitySubType = createLegacyEntitySelector<FacilitySubTypeSuggestion>({
  fetch: getProductsFacilitySubTypeSuggestions,
  queryKeyPrefix: 'venua-planner.facility-subtypes',
  objectCategory: 'FacilitySubType',
  columnHeaderKey: 'schemes.facilitySubTypeSelector.columns.name',
});

export const FacilitySubTypeSelector = facilitySubType.Selector;
export const FacilitySubTypeSelectorField = facilitySubType.Field;
